<template>
  <div class="filter">
    <custom-refinement-list
      attribute="chain"
      :transformItems="transformChainItems"
    >
      <template
        slot="item"
        slot-scope="{ item, refine }"
      >
        <label>
          <input
            type="checkbox"
            @click="refine(item.value)"
            :checked="item.isRefined"
            :value="item.value"
          />
          <span>{{ item.label }}</span>
        </label>
      </template>
    </custom-refinement-list>

    <custom-refinement-list
      attribute="chain_name"
      :sort-by="sortBy"
      searchable
    >
      <template
        slot="item"
        slot-scope="{ item, refine }"
      >
        <label>
          <input
            type="checkbox"
            @click="refine(item.value)"
            :checked="item.isRefined"
            :value="item.value"
          />
          <span>{{ item.label }}</span>
        </label>
      </template>
    </custom-refinement-list>
  </div>
</template>

<script>
import CustomRefinementList from './CustomRefinementList.vue';
import find from 'lodash/find';

export default {
  components: {
    CustomRefinementList,
  },
  methods: {
    sortBy(a, b) {
      return a.name.localeCompare(b.name);
    },
    transformChainItems(items) {
      const chainItem = find(items, item => item.value === 'true') || {
        count: 0,
        isRefined: false,
        value: 'true',
      };
      const independentItem = find(items, item => item.value === 'false') || {
        count: 0,
        isRefined: false,
        value: 'false',
      };
      return [
        { ...chainItem, label: 'Brand Restaurant' },
        { ...independentItem, label: 'Independent Restaurant' },
      ];
    },
  },
};
</script>


<style lang="scss" scoped>
.filter {
  color: #333;
}

/deep/ {
  .ais {
    &-SearchBox-form {
      display: flex;
      margin-top: 5px;
      margin-bottom: 15px;
      padding: 9px 0;
      border-bottom: 1px solid rgba($black, 0.5);
    }
    &-SearchBox-input {
      padding: 0;
      background: none;
      font-family: inherit;
      font-size: inherit;
      color: $black;
      border: none;
      flex-grow: 1;
      order: 2;
      appearance: none;
    }
    &-SearchBox-submit,
    &-SearchBox-reset {
      padding: 0;
      background: none;
      border: none;
    }
    &-SearchBox-submit {
      width: 20px;
      height: 20px;
      margin-right: 9px;
      order: 1;
    }
    &-SearchBox-submitIcon {
      height: 100%;
      width: 100%;
    }
    &-SearchBox-reset {
      fill: darken($alabaster-white, 20%);
      cursor: pointer;
      order: 3;
    }
  }
}
</style>
